export default __webpack_public_path__ + "static/media/character_voice_actor_name.f26e9bbd.png";